import styled from 'styled-components';

export const LayoutContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.color.white};
`;
